<form class="gap-lg flex flex-col" [formGroup]="form">
  <div>
    <label for="nom" hlmLabel labelRequired>Nom de la modalité</label>
    <input id="nom" hlmInput formControlName="nom" />
  </div>
</form>
